import buildingIcon from '../../styles/svgs/building.svg';
import homeIcon from '../../styles/svgs/home.svg';

export const propertyTypes = [
  {
    iconPath: buildingIcon,
    translationPath: 'property.propertyTypes.apartment',
    value: 'apartment',
  },
  {
    iconPath: homeIcon,
    translationPath: 'property.propertyTypes.house',
    value: 'house',
  },
];

export const usePurposes = [
  {
    translationPath: 'propertyCalculator.usePurposes.own',
    value: 'own',
  },
  {
    translationPath: 'propertyCalculator.usePurposes.rent',
    value: 'rent',
  },
];
